// ESM-Huelle - seit RKSV-Umbau (tools/RKSV-ONLINE-SIGNATUR.md 6): die Kasse
// spricht NICHT mehr selbst mit FinanzOnline. Zugangsdaten (TID/BENID/PIN)
// liegen nur noch im Zentraldienst (rksv.json); die Oberflaeche fragt ueber
// ihren lokalen Kassenserver (POST rksv/fon), der an die Zentrale weiterreicht.
// Aufrufer und Callback-Semantik bleiben: startWebservice(name, callback(success), arg).
function CWebservice() {}

// Nacharbeit B: 'ausserbetriebnahme_kasse' = ENDGUELTIGE Ausserbetriebnahme
// (Menue "Beim Finanzamt abmelden", Grund 6); 'schlussbelegpruefung' =
// belegpruefung des Schlussbelegs (die Zentrale vermerkt sie fuer die
// Wiederholung). 'ausserbetriebnahme' meldet (Ruling 31) einen AUSFALL der
// Kasse (ausfall_kasse, Grund 99) - der Menuepunkt nutzt ihn nicht mehr.
CWebservice.prototype.startWebservice = function (servicename, callback, arg1) {
    var operation = { belegpruefung: 'belegpruefung', schlussbelegpruefung: 'belegpruefung', wiederinbetriebnahme: 'wiederinbetriebnahme_kasse',
        ausserbetriebnahme: 'ausfall_kasse', ausserbetriebnahme_kasse: 'ausserbetriebnahme_kasse' }[servicename];
    if (!operation) {
        log.add(1, "Error", "Webservice", "unbekannter Dienst " + servicename);
        if (callback) callback(false);
        return;
    }
    $.ajax({ url: "rksv/fon", type: "POST", contentType: "application/json", timeout: 90000,
        data: JSON.stringify(operation === 'belegpruefung' ? (servicename === 'schlussbelegpruefung' ? { operation: operation, beleg: arg1, schlussbeleg: true }
            : { operation: operation, beleg: arg1 }) : { operation: operation }),
        success: function (a) {
            log.add(2, "Info", "Webservice " + operation, a && a.text);
            if (callback) callback(!!(a && a.ok));
        },
        error: function (xhr) {
            log.add(1, " FONError ", " Connection Error : " + (xhr && xhr.status));
            var text = "Keine Verbindung zum Finanzserver!\nBitte noch einmal oder sp&auml;ter versuchen! ";
            POS.message.show(text, "warning", "OK");
            if (callback) callback(false);
        }
    });
};

export { CWebservice };
